/* eslint-disable */
import React from "react";
import { Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import LabelWithLink from "../LabelWithLink/LabelWithLink";

const LoginFormFields = ({ formError }: { formError: string | null }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  return (
    <>
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: "E-mail is required",
          },
        ]}
        label="E-mail"
      >
        <Input autoFocus autoComplete="on" tabIndex={1} />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "Password is required",
          },
        ]}
        label={
          <LabelWithLink
            labelTitle="Password"
            linkTitle="Forgot Password?"
            onClick={() => navigate("/forgot-password")}
            tabIndex={4}
          />
        }
      >
        <Input type="password" autoComplete="off" tabIndex={2} />
      </Form.Item>
      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            className="form-button"
            disabled={
              (formError === null && !form.isFieldsTouched(true)) ||
              !!form.getFieldsError().filter(({ errors }) => errors.length)
                .length
            }
            tabIndex={3}
          >
            sign in
          </Button>
        )}
      </Form.Item>
    </>
  );
};

export default LoginFormFields;
